var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHandSetIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.856 13.144C9.68602 11.974 8.80402 10.664 8.21802 9.33499C8.09402 9.05399 8.16702 8.72499 8.38402 8.50799L9.20302 7.68999C9.87402 7.01899 9.87402 6.06999 9.28802 5.48399L8.11402 4.30999C7.33302 3.52899 6.06702 3.52899 5.28602 4.30999L4.63402 4.96199C3.89302 5.70299 3.58402 6.77199 3.78402 7.83199C4.27802 10.445 5.79602 13.306 8.24502 15.755C10.694 18.204 13.555 19.722 16.168 20.216C17.228 20.416 18.297 20.107 19.038 19.366L19.689 18.715C20.47 17.934 20.47 16.668 19.689 15.887L18.516 14.714C17.93 14.128 16.98 14.128 16.395 14.714L15.492 15.618C15.275 15.835 14.946 15.908 14.665 15.784C13.336 15.197 12.026 14.314 10.856 13.144Z",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHandSetIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HandSetIcon.9a71742c.svg";
export { ForwardRef as ReactComponent };